export default __webpack_public_path__ + "static/media/Shield-active New.aeadbd68.svg";